var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0391 5.26694L28.4703 25.0669C28.5757 25.2494 28.6311 25.4563 28.6311 25.6669C28.6311 25.8776 28.5757 26.0845 28.4704 26.2669C28.365 26.4493 28.2136 26.6008 28.0311 26.7062C27.8487 26.8115 27.6418 26.8669 27.4311 26.8669H4.56874C4.3581 26.8669 4.15117 26.8115 3.96875 26.7062C3.78634 26.6008 3.63485 26.4493 3.52954 26.2669C3.42422 26.0845 3.36877 25.8776 3.36877 25.6669C3.36878 25.4563 3.42422 25.2494 3.52954 25.0669L14.9607 5.26694C15.0661 5.08453 15.2176 4.93306 15.4 4.82775C15.5824 4.72243 15.7893 4.66699 15.9999 4.66699C16.2106 4.66699 16.4175 4.72243 16.5999 4.82775C16.7823 4.93306 16.9338 5.08453 17.0391 5.26694ZM6.64714 24.4669H25.3527L15.9999 8.26694L6.64714 24.4669ZM14.7999 20.8669H17.1999V23.2669H14.7999V20.8669ZM14.7999 12.4669H17.1999V18.4669H14.7999V12.4669Z",
    fill: "#FFB330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.9f8223fdeeb6f7470629584bc15d7ba7.svg";
export { ForwardRef as ReactComponent };